import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Bill} from './bill';
import {BaseInfoService} from 'app/services/base-info.service';

@Component({
  selector: 'app-bill-type',
  templateUrl: './bill-type.component.html',
  styleUrls: ['./bill-type.component.scss']
})
export class BillTypeComponent implements OnInit {
  selectedBillType: Bill = {
    billType: '',
    name: ''
  };
  billTypeList: Bill[] = [];
  @Input() hasError;
  @Output() billTypeNameString: EventEmitter<any> = new EventEmitter();
  constructor(
    private baseInfo: BaseInfoService) { }

  ngOnInit() {
    document.getElementById('billTypeId').classList.add('hide_selected');
    if (JSON.parse(localStorage.getItem('billTypeList')) === null) {
        this.getBillTypes();
    } else {
      this.billTypeList = JSON.parse(localStorage.getItem('billTypeList'));
    }
  }
  getBillTypes() {
    this.baseInfo.getBillTypes()
      .subscribe(
        res => {
          if (res.code === 0) {
            this.billTypeList = res.content;
            localStorage.setItem('billTypeList', JSON.stringify(this.billTypeList));
          }
        }
      );
  }
  sendBillName() {
    document.getElementById('billTypeId').classList.add('focused');
    this.billTypeNameString.emit(this.selectedBillType);
  }
  selectFirst() {
    document.getElementById('billTypeId').classList.remove('hide_selected');
    if (this.billTypeList.length > 0 && this.selectedBillType.billType === '') {
      document.getElementById('billTypeId').classList.add('focused');
      this.selectedBillType = this.billTypeList[0];
      this.billTypeNameString.emit(this.selectedBillType);
    }
  }
}
